import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Search, Bell } from "lucide-react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";

export function TopBar() {
  const [q, setQ] = useState("");
  const [unread, setUnread] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();
  const { user } = useAuth();

  useEffect(() => {
    let alive = true;
    const load = async () => {
      try {
        const { data } = await api.get("/notifications");
        if (alive) setUnread(data.filter((n) => !n.read).length);
      } catch {
        /* ignore */
      }
    };
    if (user) load();
    return () => {
      alive = false;
    };
  }, [user, location.pathname]);

  const onSubmit = (e) => {
    e.preventDefault();
    const query = q.trim();
    if (query) navigate(`/library?q=${encodeURIComponent(query)}`);
  };

  return (
    <div className="sticky top-0 z-20 -mx-4 sm:-mx-6 px-4 sm:px-6 pt-4 pb-3 bg-gradient-to-b from-[#05070D]/95 via-[#05070D]/70 to-transparent backdrop-blur-sm">
      <div className="flex items-center gap-3">
        <form onSubmit={onSubmit} className="flex-1 relative">
          <input
            data-testid="global-search-input"
            value={q}
            onChange={(e) => setQ(e.target.value)}
            placeholder="Ask anything… find an SOP, folder, owner"
            className="w-full rounded-full bg-white/[0.04] backdrop-blur-xl border border-white/10 pl-6 pr-12 py-3.5 text-[#F5F7FA] placeholder-[#5B6472] focus:outline-none focus:border-cyan-400/60 focus:shadow-[0_4px_28px_-6px_rgba(6,182,212,0.35)] transition-all"
          />
          <button
            type="submit"
            className="absolute right-2 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-gradient-to-br from-[#2563EB] to-[#4F46E5] flex items-center justify-center text-white hover:shadow-[0_0_16px_rgba(79,70,229,0.6)] transition"
            aria-label="Search"
          >
            <Search size={16} />
          </button>
        </form>
        <button
          onClick={() => navigate("/notifications")}
          className="relative w-11 h-11 rounded-full glass hover:bg-white/[0.08] flex items-center justify-center transition"
          data-testid="topbar-notif-btn"
          aria-label="Notifications"
        >
          <Bell size={18} className="text-white" />
          {unread > 0 && (
            <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full bg-gradient-to-br from-rose-500 to-orange-500 text-[10px] font-semibold text-white flex items-center justify-center border border-[#05070D]">
              {unread > 9 ? "9+" : unread}
            </span>
          )}
        </button>
      </div>
    </div>
  );
}
